import React, { useContext, useEffect, useState } from "react";
import Sidebar from "../../layout/Sidebar/SideBar";
import Navbar from "../../layout/Navbar/Navbar";
import blogFetch from "../../axios/config";
import { ISAGA_Apontamento_SAP } from "./sapNotificationsInterfaces";
import Loading from "../../components/Loading";

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Select, MenuItem } from '@mui/material';
import { ListItemText, InputLabel, FormControl, Checkbox } from '@mui/material';
import { Button } from "@mui/material";

import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br'
import { Container, Row } from "react-bootstrap";
import { ApontamentoPendente } from "./components/apontamentosPendentes";
import { HistoricoApontamento } from "./components/historicoApontamentos";

export const SAPNotifications = () => {

  const [apontamentosHistorico, setApontamentosHistorico] = useState<ISAGA_Apontamento_SAP[]>([]);
  const [apontamentosPendentes, setApontamentosPendentes] = useState<ISAGA_Apontamento_SAP[]>([]);

  const tiposApontamentos: string[] = [
    "APROVADO",
    "REFUGO",
    "REPROCESSO"
  ];
  const [selectedApontamentos, setselectedApontamentos] = useState<string[]>(tiposApontamentos);

  const setores: string[] = [
    "01CORTE",
    "01HIDCOR",
    "03SERIG",
    "05EMPOLV",
    "06CURVAD",
    "09IOX_E",
    "09IOX_S",
    "12P_MONT",
    "13PRE_IB",
    "14MONTAG",
    "15EMBOL",
    "16ACV",
    "18INSFIN",
    "57LABORA"
  ];
  const [selectedSetor, setselectedSetor] = useState<string>("06CURVAD");
  const [dtInicio, setDtInicio] = useState<Date>(() => {
    const date = new Date();
    date.setDate(date.getDate() - 5);
    return date;
  });

  const [dtFim, setDtFim] = useState<Date>(new Date());


  const handleSelectSetor = (event: { target: { value: any; }; }) => {
    const {
      target: { value },
    } = event;
    setselectedSetor(value);
  };

  const handleSelectApontamentos = (event: { target: { value: any; }; }) => {
    const {
      target: { value },
    } = event;
    setselectedApontamentos(
      typeof value === 'string' ? value.split(',') : value,
    );
  };


  const getApontamentosPendentes = async (Setor: string) => {
    try {
      const { data } = await blogFetch.get(`/ISAGA_ApontamentoSAP/getApontamentoSAPPendentes?Setor=` + Setor);

      setApontamentosPendentes(data);
    } catch (error) {
      console.error(error);
    }
  };

  const getApontamentosHistorico = async () => {
    try {
      var str_dtInicio = dtInicio.toISOString().split('T')[0];
      var str_dtFim = dtFim.toISOString().split('T')[0];

      const { data } = await blogFetch.get(`/ISAGA_ApontamentoSAP/getApontamentoSAPHistorico?DtInicio=` + str_dtInicio + `&DtFim=` + str_dtFim + `&ApontStatus=` + selectedApontamentos.join(',') + `&Setor=` + selectedSetor);

      setApontamentosHistorico(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getApontamentosPendentes(selectedSetor);
    getApontamentosHistorico();
  }, [dtInicio, dtFim, selectedApontamentos, selectedSetor]);

  return (
    <>
      <Navbar />
      <Sidebar />
      <div className="app_body">

        <Container fluid>
          <Row>
            <ApontamentoPendente />
          </Row>
          <Row>
            <HistoricoApontamento />
          </Row>
        </Container>
      </div>

    </>
  )
}

